import { Controller } from "stimulus"

export default class extends Controller {

  toggleOptions(event) {
    const holdRatings = event.target.checked
    const optionsDiv = document.getElementById('hold-ratings-options')
    
    if (holdRatings) {
      optionsDiv.style.display = 'block'
    } else {
      optionsDiv.style.display = 'none'
      // Uncheck indefinite hold if main hold is unchecked
      const indefiniteCheckbox = optionsDiv.querySelector('input[type="checkbox"]')
      if (indefiniteCheckbox) {
        indefiniteCheckbox.checked = false
      }
    }
  }
}